export interface AccommodationAgreementDetails {
  fullName: unknown;
  relationship: unknown;
  guardianName: unknown;
  place: unknown;
}

const RELATIONSHIP_LABELS: Record<string, string> = {
  son: 'S/O',
  daughter: 'D/O',
  wife: 'W/O',
};

function text(value: unknown): string {
  return String(value ?? '').trim();
}

/** Builds the agreement text submitted by both primary- and family-code flows. */
export function buildAccommodationAgreement(
  details: AccommodationAgreementDetails,
): string {
  const relationship = text(details.relationship).toLowerCase();
  const relationshipLabel = RELATIONSHIP_LABELS[relationship]
    ?? text(details.relationship).toUpperCase();

  return `By checking the box, I confirm that I have read and accepted the Terms & Conditions at https://app.acco.satsangphilanthropy.com/#/termsnconditions and the accommodation guidelines at https://app.acco.satsangphilanthropy.com/#/guidelinesnfaqs. I will communicate them to every visitor included in the booking and accept responsibility for compliance. I, ${text(details.fullName)}, ${relationshipLabel} ${text(details.guardianName)}, from ${text(details.place)}, agree to these terms, conditions, and guidelines.`;
}
